export const siteInfo = {
  name: '人人出彩',
  fullName: '人人出彩官网',
  tagline: '发现你的闪光时刻',
  description: '人人出彩是一个面向普通人的才华展示与故事分享平台。我们致力于让每一个平凡的人都能展示自己不凡的才华与故事，无论你是谁，无论你来自哪里，这里都有属于你的舞台。',
  url: 'https://www.renrenchucai.com',
  email: 'hello@renrenchucai.com',
  phone: '400-888-9999',
  address: '北京市朝阳区望京SOHO T1 18层',
  foundingYear: 2023,
  stats: {
    totalUsers: '580,000+',
    totalStories: '1,200,000+',
    totalCategories: '12',
    monthlyActive: '320,000+',
  },
  social: {
    weibo: 'https://weibo.com/renrenchucai',
    wechat: 'renrenchucai',
    douyin: '@人人出彩',
  },
  brandStory: '人人出彩创立于2023年，源于一个简单的信念——每个人都有属于自己的闪光点。我们的创始团队来自不同的行业背景，却有着共同的使命：为每一个普通人搭建一个展示自我、分享故事的舞台。我们相信，才华不分高低，故事不论大小，每一个生命都值得被看见、被聆听。从最初的一个小小社区，到如今汇聚超过58万用户的出彩平台，人人出彩正在用行动证明：平凡的你我，也可以拥有不凡的出彩时刻。',
  mission: '让每一个普通人都能展示才华，让每一个故事都能被世界听见。',
  vision: '成为全球最大的普通人才华展示与故事分享社区。',
  teamMembers: [
    { name: '李明远', role: '创始人 & CEO', description: '连续创业者，前阿里巴巴产品总监，相信技术应该为普通人赋能。' },
    { name: '王思涵', role: '联合创始人 & COO', description: '前腾讯社区运营负责人，深耕内容社区领域超过10年。' },
    { name: '张雨辰', role: 'CTO', description: '前字节跳动高级工程师，专注于构建高性能、可扩展的技术平台。' },
    { name: '陈晓琳', role: '设计总监', description: '前网易UEDC设计专家，致力于打造温暖而有力量的产品体验。' },
  ],
  testimonials: [
    {
      name: '赵云飞',
      title: '自由音乐人',
      content: '在人人出彩分享我的原创音乐后，收到了很多温暖的鼓励和专业的建议。这里的人真的很真诚，让我找到了继续创作的动力。',
      avatar: '',
    },
    {
      name: '林小薇',
      title: '手工艺爱好者',
      content: '我一直觉得自己的手工作品很普通，但在人人出彩分享后，竟然收到了上百个点赞！还有人专门私信问能不能买，真的太惊喜了。',
      avatar: '',
    },
    {
      name: '孙浩宇',
      title: '摄影博主',
      content: '人人出彩让我从一个默默无闻的摄影爱好者变成了拥有五万粉丝的创作者。这里没有浮躁的氛围，大家都在用心分享和交流。',
      avatar: '',
    },
    {
      name: '周美琪',
      title: '美食达人',
      content: '作为一个普通的家庭主妇，没想到我分享的家常菜谱能得到这么多人的喜爱。人人出彩让我重新认识了自己的价值。',
      avatar: '',
    },
  ],
  faqs: [
    {
      q: '人人出彩是免费的吗？',
      a: '是的，人人出彩平台完全免费！我们致力于为每一个普通人提供免费的才华展示和故事分享空间，不收取任何费用。',
    },
    {
      q: '如何开始分享我的故事？',
      a: '注册账号后，点击"发布"按钮即可开始创作。你可以发布文章、图片、视频等多种形式的内容，讲述你的才华与故事。',
    },
    {
      q: '平台支持哪些类型的才华展示？',
      a: '我们支持音乐、舞蹈、绘画、写作、摄影、美食、手工、科技、运动、旅行、演讲等各类才华的展示。平台持续扩展新的分类，欢迎各种形式的创意表达。',
    },
    {
      q: '我的故事会被很多人看到吗？',
      a: '平台会根据内容质量和用户兴趣进行智能推荐，优质的内容会被推送给更多用户。我们还会定期举办主题活动和评选，帮助优秀创作者获得更多曝光。',
    },
    {
      q: '个人隐私安全有保障吗？',
      a: '我们非常重视用户隐私保护，采用业界领先的安全技术保障您的数据安全。您可以在设置中自由控制个人信息的可见范围。',
    },
  ],
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类', href: '/category/all' },
  { label: '关于我们', href: '/about' },
];